<div [class]="cssClass">
  <div [class.labelled]="label" class="iv-input-number">
    <span *ngIf="label" class="label">{{label}}</span>
    <span *ngIf="label" class="separator">|</span>
    <input (change)="onChange()" [(ngModel)]="selectedData" class="value" type="number">
    <i (click)="increaseCenter()" class="material-icons increase">&#xE5C7;</i>
    <i (click)="decreaseCenter()" class="material-icons decrease">&#xE5C5;</i>
  </div>
</div>
